import React from "react";
import FAQAccordion from '../FAQAccordion';

class NevadaInfo extends React.Component {
  render() {
    return (
      <React.Fragment>
        <section className="about-us pt-trip gray-light-bg">
          <div className="container">
            <div className="row justify-content-center">
              <div className="col-md-10">

                <p>
                  Most people come to Las Vegas for the casinos, the shows, and the nightlife — and leave without knowing that the surrounding desert is one of the most dramatic and accessible outdoor landscapes in the country.{" "}
                  <strong>Red Rock Canyon is 30 minutes from the Strip.</strong> Valley of Fire is an hour away. Lake Mead and the Hoover Dam are even closer. You can hike slot canyons, mountain bike alongside Joshua trees, or kayak on the Colorado River — all as a day trip from your hotel.
                </p>

                <h2>Red Rock Canyon National Conservation Area</h2>
                <p>
                  The single best outdoor day trip from Las Vegas. The{" "}
                  <a href="https://www.blm.gov/programs/national-conservation-lands/nevada/red-rock-canyon" target="_blank" rel="noopener noreferrer">
                    Red Rock Canyon Scenic Drive
                  </a>{" "}
                  is a 13-mile one-way loop through massive Aztec sandstone formations in shades of deep red, orange, and cream. The contrast with the desert scrub is jaw-dropping — especially in the morning when the rock glows in low light.
                </p>
                <ul>
                  <li><strong>Calico Hills Trail</strong> — easy 2.5-mile loop through red and white layered rock; great for families</li>
                  <li><strong>Turtlehead Peak</strong> — strenuous 5.8-mile out-and-back to a summit with panoramic views; 2,000 ft elevation gain</li>
                  <li><strong>Ice Box Canyon</strong> — moderate 2.7-mile trail ending at a seasonal waterfall in a narrow canyon</li>
                  <li><strong>Entry fee:</strong> $15/vehicle; timed entry reservations required February–October</li>
                  <li><strong>Best time:</strong> Arrive at opening (6am) to beat the heat and secure parking</li>
                </ul>

                <h2>Valley of Fire State Park</h2>
                <p>
                  About an hour northeast of Las Vegas,{" "}
                  <a href="https://parks.nv.gov/parks/valley-of-fire" target="_blank" rel="noopener noreferrer">
                    Valley of Fire
                  </a>{" "}
                  is Nevada's oldest state park and one of the most visually striking places in the American West. Bright crimson Aztec sandstone formations rise from the Mojave Desert in shapes that look almost alien. The light here at sunrise and sunset is unforgettable for photography.
                </p>
                <ul>
                  <li><strong>Fire Wave</strong> — 1.5-mile round trip to a swirling pink and red sandstone formation; very popular, go early</li>
                  <li><strong>White Domes Loop</strong> — 1.1-mile loop through slot canyons, white sandstone, and an old movie set</li>
                  <li><strong>Elephant Rock</strong> — short 0.3-mile walk to a natural rock formation shaped like an elephant</li>
                  <li><strong>Entry fee:</strong> $10/vehicle for Nevada residents, $15 for out-of-state</li>
                </ul>

                <h2>Lake Mead & Hoover Dam</h2>
                <p>
                  Just 30 miles southeast of the Strip,{" "}
                  <strong>Lake Mead</strong> is the largest reservoir in the US by volume (when full) and offers kayaking, paddleboarding, and swimming in crystal-clear blue water surrounded by desert canyon walls. Launch from Boulder Beach for calm, beginner-friendly paddling.
                </p>
                <p>
                  The{" "}
                  <strong>Hoover Dam</strong> is right next door and worth a quick stop — the powerplant tour is genuinely interesting and the views from the dam wall looking down into Black Canyon are vertiginous in the best way. Budget 1.5–2 hours.
                </p>

                <h2>Mountain Biking in Las Vegas</h2>
                <p>
                  The Vegas metro has a surprisingly strong MTB scene. The{" "}
                  <strong>Bootleg Canyon Bike Park</strong> in Boulder City (30 min from the Strip) has over 35 miles of singletrack ranging from beginner flow trails to expert downhill runs with spectacular views of Lake Mead. Bike rentals are available on site.
                </p>

                <h2>Day Trip to Zion National Park</h2>
                <p>
                  Zion is 2.5 hours from Las Vegas — an easy day trip if you're willing to start early. Head north on I-15 through the dramatic Virgin River Gorge in Arizona, then into Utah through the town of St. George. The Zion Narrows bottom-up hike is iconic but requires a permit; the Emerald Pools trails are permit-free and stunning. See the full{" "}
                  <a href="/itineraries/utah-national-parks-road-trip">Utah National Parks itinerary</a>{" "}
                  if you want to make it a multi-day trip.
                </p>

                <h2>Practical Tips</h2>
                <ul>
                  <li><strong>Rent a car</strong> — public transit doesn't reach any of these locations</li>
                  <li><strong>Start early</strong> — summer temperatures in the desert routinely exceed 110°F; most hiking should be done before 10am</li>
                  <li><strong>Water</strong> — carry at least 3L per person for any hike; there are no water sources in the desert</li>
                  <li><strong>Best seasons</strong> — October–April; summer is doable with early starts but genuinely dangerous for long hikes</li>
                </ul>
                <p>
                  To view the full Las Vegas outdoor itinerary route — Red Rock Canyon, Valley of Fire, and Lake Mead —{" "}
                  <strong>click "more options" on the Google Maps embed above</strong>.
                </p>

                <FAQAccordion
                  title="Things to Do in Las Vegas FAQs"
                  items={[
                    { q: 'What outdoor activities are near Las Vegas?', a: 'Red Rock Canyon, Valley of Fire, Lake Mead, Spring Mountains (Mt. Charleston), Hoover Dam, and Zion National Park are all within 1–2 hours of the Strip. Las Vegas has some of the best desert outdoor access in the country.' },
                    { q: 'How far is Red Rock Canyon from the Las Vegas Strip?', a: 'About 17 miles or a 25-minute drive. You can be hiking sandstone canyons within 30 minutes of leaving your hotel.' },
                    { q: 'Is Valley of Fire worth visiting from Las Vegas?', a: "Absolutely. Valley of Fire is one of Nevada's most dramatic landscapes — ancient red sandstone formations, petroglyphs, and surreal desert scenery just 50 miles from Las Vegas." },
                    { q: 'Can you day trip to Zion from Las Vegas?', a: 'Yes — Zion is about 2.5 hours from Las Vegas. You can do a full day at the park, including the Narrows or Riverside Walk, and return the same evening.' },
                    { q: 'Is mountain biking good near Las Vegas?', a: 'Yes — the Bootleg Canyon trail system in Boulder City and the trails at Red Rock Canyon offer excellent mountain biking. Bootleg Canyon has gravity-fed downhill trails suitable for all skill levels.' },
                    { q: 'What is the best time to visit Las Vegas for outdoor activities?', a: 'October through April is ideal. Spring and fall are perfect for hiking and biking. Summer temperatures regularly exceed 110°F in the desert — outdoor activities should be done early morning only.' },
                    { q: 'Do you need a permit for Red Rock Canyon?', a: 'A timed entry reservation is required from October through May to drive the scenic loop. Hiking from the visitor center area does not require a reservation. Check recreation.gov for current requirements.' },
                  ]}
                />

              </div>
            </div>
          </div>
        </section>
      </React.Fragment>
    );
  }
}

export default NevadaInfo;
